/**
 * Partie de démonstration, clairement identifiée comme telle dans l'UI
 * (voir ParsedGame.isDemo). Le joueur y incarne les Noirs, qui reprennent
 * la dame en g4 avec le cavalier (15... Nxg4??) sans voir que le pion h3
 * peut simplement le capturer (16. hxg4), perdant une pièce entière.
 * Cette séquence a été vérifiée coup par coup avec chess.js (parsing et
 * relecture du PGN généré) avant intégration.
 */
export const DEMO_GAME_PGN = `[Event "Partie de démonstration Magnus"]
[Site "Local"]
[Date "2026.01.01"]
[Round "1"]
[White "Adversaire (démo)"]
[Black "Vous (démo)"]
[Result "1-0"]

1. e4 e5 2. Nf3 Nc6 3. Bc4 Bc5 4. c3 Nf6 5. d3 d6 6. O-O O-O 7. Re1 Bg4
8. Nbd2 Qd7 9. h3 Bxf3 10. Nxf3 Nd4 11. Nxd4 Bxd4 12. Be3 Bxe3 13. Rxe3
Rae8 14. Qf3 Qg4 15. Qxg4 Nxg4 16. hxg4 1-0`;
